// @flow

import React, { useContext } from 'react';
import ChampsToPlayHeaderCard from './ChampsToPlayHeaderCard.react';
import ChampsToPlayList from './ChampsToPlayList.react';
import ChallengesDataContext from '../top-level/ChallengesDataContext.react';

type SummonerAndRegion = {
  summoner: string,
  region: string,
};

type Props = {
  lookupTarget: SummonerAndRegion,
};

function ChampsToPlayView(props: Props): React.Element {
  const { masteryData } = useContext(ChallengesDataContext);

  return (
    <div className="champsToPlayContainer">
      <ChampsToPlayHeaderCard />
      <ChampsToPlayList masteryData={masteryData} />
    </div>
  );
}

export default ChampsToPlayView;
